import React from 'react';
import t from '~t';
import config from '~config';

import { Label, Button, Icon } from '~ui';

export default function ProHelp() {
  return (
    <>
      <Label>{t.s('info')}</Label>
      <div className='flex flex-wrap justify-self-start [&>:not(:last-child)]:mr-[var(--padding-small)]'>
        <Button asChild variant='ghost'>
          <a href={config.links.pro.compare} target='_blank'>
            <Icon name='cloud' size='micro' />
            {t.s('allFeatures')}
          </a>
        </Button>

        <Button asChild variant='ghost'>
          <a href={config.links.pro.buy} target='_blank'>
            <Icon name='list' size='micro' />
            {t.s('comparePlans')}
          </a>
        </Button>

        <Button asChild variant='ghost'>
          <a href={config.links.pro.faq} target='_blank'>
            <Icon name='open' size='micro' />
            FAQ
          </a>
        </Button>
      </div>
    </>
  );
}
